var _path, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeniedCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.333C7 17.2284 7.89543 16.333 9 16.333H16.2639C17.0215 16.333 17.714 15.905 18.0528 15.2274L20.4472 10.4386C20.786 9.76101 21.4785 9.33301 22.2361 9.33301H33.7639C34.5215 9.33301 35.214 9.76101 35.5528 10.4386L37.9472 15.2274C38.286 15.905 38.9785 16.333 39.7361 16.333H47C48.1046 16.333 49 17.2284 49 18.333V44.6663C49 45.7709 48.1046 46.6663 47 46.6663H9C7.89543 46.6663 7 45.7709 7 44.6663V18.333Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 31,
    r: 8,
    fill: "#1E1F22"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52.4689,
    y1: 11.547,
    x2: 11.6808,
    y2: 52.3351,
    stroke: "#1E1F22",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 49.8478,
    y1: 10.0607,
    x2: 9.05971,
    y2: 50.8487,
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeniedCamera);
export default __webpack_public_path__ + "static/media/deniedCamera.3bbfa0808437f4f7cc912dc078049019.svg";
export { ForwardRef as ReactComponent };